var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopFields(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17264",
    "data-name": "Group 17264",
    transform: "translate(19736 15768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mortarboard_1_",
    "data-name": "mortarboard (1)",
    transform: "translate(-19735 -15798.135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8321",
    "data-name": "Path 8321",
    d: "M419.263,184.531v-3.919l-.738.246v3.673a1.162,1.162,0,0,0-.791,1.1v1.977a.369.369,0,0,0,.369.369h1.582a.369.369,0,0,0,.369-.369v-1.977A1.162,1.162,0,0,0,419.263,184.531Z",
    transform: "translate(-407.453 -144.823)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8322",
    "data-name": "Path 8322",
    d: "M99.978,203.227,96.4,202.034v2.514a.369.369,0,0,0,.108.261,5.4,5.4,0,0,0,7.639,0,.369.369,0,0,0,.108-.261v-2.514l-3.578,1.193A1.108,1.108,0,0,1,99.978,203.227Z",
    transform: "translate(-94.028 -165.717)",
    fill: "#f9b316"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8323",
    "data-name": "Path 8323",
    d: "M6.3,36.828a.369.369,0,0,0,.117-.019l5.931-1.977a.369.369,0,0,0,0-.7L6.417,32.154a.37.37,0,0,0-.233,0L.252,34.131a.369.369,0,0,0,0,.7l5.931,1.977a.369.369,0,0,0,.117.019Z",
    fill: "#f9b316"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2240",
    "data-name": "Rectangle 2240",
    width: 16,
    height: 16,
    transform: "translate(-19736 -15768)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopFields);
export default __webpack_public_path__ + "static/media/top_fields.190ff67335463c51448650fc3a1170a0.svg";
export { ForwardRef as ReactComponent };